import cx from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { SLDSIcon } from '@salesforce/design-system-react';

function Icon({
  assistiveText,
  category = "utility",
  className,
  name,
  size = "medium",
  ...props
}) {
  return /*#__PURE__*/React.createElement(SLDSIcon, Object.assign({
    className: cx(className)
  }, props, {
    assistiveText: assistiveText,
    category: category,
    name: name,
    size: size
  }));
}
Icon.displayName = "Icon";
Icon.propTypes = {
  /**
   * a11y label
   */
  assistiveText: PropTypes.shape({
    label: PropTypes.string
  }),
  /**
   * Icon categiry.
   */
  category: PropTypes.oneOf(["utility", "action", "custom", "standard", "doctype"]),
  /**
   * CSS class to be applied to the wrapper element.
   */
  className: PropTypes.string,
  /**
   * Icon name. Name and Category controls which icon shows up.
   */
  name: PropTypes.string.isRequired,
  /**
   * Icon size.
   */
  size: PropTypes.oneOf(["xx-small", "x-small", "small", "medium", "large"])
};
Icon.defaultProps = {
  assistiveText: {},
  category: "utility",
  className: null,
  size: "medium"
};

export { Icon as default };
